import { AlertTriangle } from "lucide-react";

export const ConfirmDialog = ({ title, message, confirmLabel = "Eliminar", cancelLabel = "Cancelar", tone = "danger", onConfirm, onCancel }) => (
  <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={(e) => { e.stopPropagation(); onCancel(); }} data-testid="confirm-dialog">
    <div className="w-full max-w-sm bg-[#121214] border border-white/10 rounded-2xl p-6 animate-pop" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-start gap-3">
        <div className={`h-10 w-10 shrink-0 rounded-full flex items-center justify-center ${tone === "danger" ? "bg-red-500/15 text-red-400" : "bg-[#FFD600]/15 text-[#FFD600]"}`}>
          <AlertTriangle className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-bold">{title}</h3>
          <p className="text-sm text-zinc-400 mt-1">{message}</p>
        </div>
      </div>
      <div className="flex gap-2 justify-end mt-5">
        {cancelLabel && <button onClick={onCancel} data-testid="confirm-cancel"
          className="px-4 py-2 rounded-lg text-sm font-semibold text-zinc-300 bg-white/5 hover:bg-white/10 transition-colors">{cancelLabel}</button>}
        <button onClick={onConfirm} data-testid="confirm-accept"
          className={`px-4 py-2 rounded-lg text-sm font-semibold text-white transition-colors ${tone === "danger" ? "bg-red-500 hover:bg-red-600" : "bg-primary hover:bg-[#FF5047]"}`}>{confirmLabel}</button>
      </div>
    </div>
  </div>
);
